// Function to initialize the accordion
function initRewardsFaqAccordion() {
  // Get all FAQ question buttons and answer panels
  const faqItems = document.querySelectorAll('.rewards-faq__item');
  
  if (faqItems.length === 0) return; // Exit if no items found
  
  // First, remove any existing event listeners by cloning and replacing elements
  faqItems.forEach(item => {
    const question = item.querySelector('.rewards-faq__question');
    if (question) {
      const newQuestion = question.cloneNode(true);
      question.parentNode.replaceChild(newQuestion, question);
    }
  });
  
  // Now add fresh event listeners
  faqItems.forEach(item => {
    const question = item.querySelector('.rewards-faq__question');
    const answer = item.querySelector('.rewards-faq__answer');
    
    if (!question || !answer) return; // Skip if missing elements
    
    question.addEventListener('click', function(e) {
      e.preventDefault();
      
      const isExpanded = question.getAttribute('aria-expanded') === 'true';
      
      // First close all other items
      faqItems.forEach(otherItem => {
        if (otherItem !== item) {
          const otherQuestion = otherItem.querySelector('.rewards-faq__question');
          const otherAnswer = otherItem.querySelector('.rewards-faq__answer');
          
          if (otherQuestion && otherAnswer) {
            otherQuestion.setAttribute('aria-expanded', 'false');
            otherAnswer.style.display = 'none';
          }
        }
      });
      
      // Then toggle the clicked item
      if (isExpanded) {
        question.setAttribute('aria-expanded', 'false');
        answer.style.display = 'none';
      } else {
        question.setAttribute('aria-expanded', 'true');
        answer.style.display = 'block';
      }
    });
  });
  
  console.log('Rewards FAQ accordion initialized with ' + faqItems.length + ' items');
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', initRewardsFaqAccordion);

// Also initialize immediately in case the DOM is already loaded
initRewardsFaqAccordion();

// Re-initialize on Shopify section load events
document.addEventListener('shopify:section:load', function(event) {
  if (event.target.classList.contains('rewards-faq')) {
    initRewardsFaqAccordion();
  }
});
